"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _styledIs = _interopRequireWildcard(require("../../utils/styled-is"));
var _color = require("../../utils/color.utils");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _HBText = require("../HBText/HBText.styles");
var _HBUIProvider = require("../HBUIProvider/HBUIProvider");
var _mixins = require("../../styles/mixins");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var _excluded = ["color"],
  _excluded2 = ["align", "children", "disabled", "isNewTab", "isUsingAccentColor", "role", "tabIndex", "textType", "weight", "testId", "testIdName", "to"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Link = _styledComponents["default"].a.withConfig({
  displayName: "HBLink__Link",
  componentId: "sc-6s44im-0"
})(["", ";", " ", " ", " ", " text-decoration:underline;", " transition:color 0.2s ease-in;i{display:inline-flex;}"], function (_ref) {
  var _theme$styles;
  var textType = _ref.textType,
    propColor = _ref.color,
    theme = _ref.theme,
    isUsingAccentColor = _ref.isUsingAccentColor;
  var _ref2 = _HBText.textStyles[textType] || _HBText.newTextStyles[textType],
    styleColor = _ref2.color,
    styles = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var color = _colors["default"][propColor] || propColor || isUsingAccentColor && (theme === null || theme === void 0 || (_theme$styles = theme.styles) === null || _theme$styles === void 0 ? void 0 : _theme$styles.accent_color) || styleColor;
  var hoverColor = color ? (0, _color.darken)(color, 0.3) : 'inherit';
  return (0, _styledComponents.css)(["", " color:", ";", ";&:hover,&:focus,&:active{color:", ";", "}"], styles, color || 'inherit', (0, _mixins.setIconFillColor)(color), hoverColor, (0, _mixins.setIconFillColor)(hoverColor));
}, (0, _styledIs["default"])('align')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        text-align: ", ";\n    "])), function (props) {
  return props.align;
}), (0, _styledIs["default"])('weight')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        font-weight: ", ";\n    "])), function (props) {
  return props.weight;
}), (0, _styledIs["default"])('disabled')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: 0.25;\n        pointer-events: none;\n    "]))), (0, _styledIs.isOr)('onClick', 'href')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        cursor: pointer;\n    "]))), (0, _styledIs["default"])('noUnderline')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        text-decoration: none;\n    "]))));
var HBLink = function HBLink(props) {
  var align = props.align,
    children = props.children,
    disabled = props.disabled,
    isNewTab = props.isNewTab,
    _props$isUsingAccentC = props.isUsingAccentColor,
    isUsingAccentColor = _props$isUsingAccentC === void 0 ? false : _props$isUsingAccentC,
    _props$role = props.role,
    role = _props$role === void 0 ? 'link' : _props$role,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    textType = props.textType,
    weight = props.weight,
    testId = props.testId,
    testIdName = props.testIdName,
    to = props.to,
    baseProps = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var id = baseProps.id;
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id,
    suffix: 'link',
    componentName: 'HBLink'
  });
  var _useHBUI = (0, _HBUIProvider.useHBUI)(),
    LinkComponent = _useHBUI.LinkComponent;
  return /*#__PURE__*/_react["default"].createElement(Link, (0, _extends2["default"])({}, baseProps, {
    align: align,
    disabled: disabled,
    isUsingAccentColor: isUsingAccentColor,
    role: role,
    tabIndex: tabIndex,
    target: isNewTab ? '_blank' : undefined,
    textType: textType,
    weight: weight,
    "data-testid": finalTestId,
    to: to,
    as: to ? LinkComponent : 'a'
  }), children);
};
var _default = exports["default"] = HBLink;
//# sourceMappingURL=HBLink.js.map